export const OAUTH_SUCCESS = "OAUTH_SUCCESS";
export const SAVE_OAUTHORIZATION_CODE = "SAVE_OAUTHORIZATION_CODE";
export const CLEAR_OAUTHORIZATION_CODE = "CLEAR_OAUTHORIZATION_CODE";
